"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["isActive", "icons", "children", "size", "href", "tag", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Tag = exports.Tag = function Tag(props) {
  var isActive = props.isActive,
    icons = props.icons,
    children = props.children,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    href = props.href,
    ElementTag = props.tag,
    className = props.className,
    elementProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var elementClasses = (0, _classnames["default"])('tag', "tag_size_".concat(size), className, {
    'tag_active': isActive
  });
  var HtmlTag = href ? 'a' : ElementTag;
  var BtnComponent = HtmlTag || 'button';
  var customProps = _objectSpread(_objectSpread({}, BtnComponent === 'a' ? {
    href: href
  } : {}), BtnComponent === 'button' ? {
    type: 'button',
    role: 'checkbox',
    'aria-checked': isActive
  } : {});
  return /*#__PURE__*/_react["default"].createElement(BtnComponent, (0, _extends2["default"])({
    className: elementClasses
  }, customProps, elementProps), icons && size !== 'sm' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag__icons mr-1"
  }, icons), children);
};